/* eslint-disable no-underscore-dangle */
import { shouldPolyfill } from '@formatjs/intl-numberformat/should-polyfill';

import appPl from 'src/resources/App/app.pl';
import appEn from 'src/resources/App/app.en';

import errorPl from 'src/resources/Error/error.pl';
import errorEn from 'src/resources/Error/error.en';

import userEn from 'src/resources/User/user.en';
import userPl from 'src/resources/User/user.pl';

import orderEn from 'src/resources/Order/order.en';
import orderPl from 'src/resources/Order/order.pl';

async function polyfill(locale) {
    if (!shouldPolyfill()) {
        return;
    }

    await import('@formatjs/intl-numberformat/polyfill');

    switch (locale) {
        default:
            await import('@formatjs/intl-numberformat/locale-data/en');
            break;
        case 'pl':
            await import('@formatjs/intl-numberformat/locale-data/pl.js');
            break;
    }
}

polyfill();

export const App = {
    en: appEn,
    pl: appPl
};

export const Error = {
    en: errorEn,
    pl: errorPl
};

export const User = {
    en: userEn,
    pl: userPl
};

export const Order = {
    en: orderEn,
    pl: orderPl
};
